module.exports = __webpack_public_path__ + "static/media/offer.7da4b589.svg";